import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ArrivalsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.0161 14.0482C11.2001 13.2642 7.98411 12.4002 4.36809 11.4562L2.76009 11.0002V5.84021L4.22409 6.20021L5.16009 8.55221L10.1281 9.87221V1.61621L12.0481 2.12021L14.8081 11.1202L20.1121 12.5362C20.5121 12.6482 20.8161 12.8882 21.0241 13.2562C21.2321 13.6242 21.2841 14.0082 21.1801 14.4082C21.0761 14.8082 20.8481 15.1042 20.4961 15.2962C20.1441 15.4882 19.7681 15.5362 19.3681 15.4402L14.0161 14.0482ZM2.49609 18.5842H21.5281V20.6002H2.49609V18.5842Z'
                fill='currentColor'
            />
        </>
    ),
})

ArrivalsIcon.displayName = 'ArrivalsIcon'
